import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  categoryId: string;
};

export const getReportCategoryDetail = createQueryFn(
  QueryNameSpace.getReportCategoryDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    return await DigiobcanApi.getReportCategoryDetail(params.categoryId);
  },
);
